import styled from '@emotion/styled';

/**
 * Кнопки пагинатора — ссылки, а не `div`: страница списка адресуема, значит
 * средний клик и «открыть в новой вкладке» обязаны работать. Отсюда сброс
 * подчёркивания и наследование цвета — остальное повторяет вид `UDPagination`.
 */
export const PagerLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  padding: 0 4px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.SurfaceCultured10};
  color: ${({ theme }) => theme.colors.SurfaceRaisinBlack50};
  text-decoration: none;
  cursor: pointer;
  user-select: none;

  &.active {
    background-color: ${({ theme }) => theme.colors.AccentNaplesYellow};
    pointer-events: none;
    cursor: default;
  }

  &.disallow {
    color: ${({ theme }) => theme.colors.SurfaceRomanSilver30};
    pointer-events: none;
  }
`;

export const PagerContainer = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;
